import React, { Component } from 'react';
import { connect } from 'react-redux'; // Core Redux binding
import { Card, Button, Collapse, FormGroup, Label, Input, Badge } from 'reactstrap';
import Select from 'react-select';
import TableView from './TableView/index';
import './style.scss';
import { Preloading as preloading } from '../../../components/UI/Preloader/action';
import {
    fetchCorporateAutocomplete,
    fetchProductsByCorporate,
    downloadBulkReportExcel,
    updateBulkCases,
    fetchBulkCaseUpdationList,
    resetBulkUploadState,
    downloadBulkCaseUpdationFile,
} from './action';
import { DEFAULT_FETCH_LIST_REQUEST } from './TableView/constant';
import { toast } from "react-toastify";

const STATUS_OPTIONS = ['PENDING', 'ONHOLD'];

// Predefined status options for dropdown with visual indicators
const STATUS_DROPDOWN_OPTIONS = [
    { value: 'PENDING', label: 'Pending', color: '#ffc107' },
    { value: 'ONHOLD', label: 'On Hold', color: '#17a2b8' }
];

class CreateBulkCaseUpdation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            caseType: 'Bulk Case',
            showDropdownList: false,
            updateFlag: false,
            isFilterOpen: true,
            corporateSearchTerm: '',
            selectedCorporate: null,
            // REMOVED: local productOptions state to rely entirely on Redux architecture
            selectedProducts: [],
           selectedStatuses: [STATUS_DROPDOWN_OPTIONS[0].value],
            selectedStatusFilter: STATUS_DROPDOWN_OPTIONS[0],
                startDate: '',
            endDate: '',
            transactionFile: null,
            uploadError: [],
            selectedCaseType: 'DOMESTIC',
           
            openModal: false,
        };

        this.debounceTimer = null;
    }

    componentDidMount() {

        this.props.fetchBulkCaseUpdationList(DEFAULT_FETCH_LIST_REQUEST);
    }

   componentDidUpdate(prevProps) {
    const {
        downloadLoading, downloadError,
        uploadLoading, uploadError, uploadSuccessMessage,
        fileDownloadLoading, fileDownloadUrl, fileDownloadError,
    } = this.props;

    const isCurrentlyWorking = downloadLoading || uploadLoading || fileDownloadLoading;
    const wasPreviouslyWorking = prevProps.downloadLoading || prevProps.uploadLoading || prevProps.fileDownloadLoading;

    if (isCurrentlyWorking !== wasPreviouslyWorking) {
        this.props.preloading(isCurrentlyWorking);
    }

    if (fileDownloadUrl && fileDownloadUrl !== prevProps.fileDownloadUrl) {
        window.open(fileDownloadUrl);
    }

    if (fileDownloadError && fileDownloadError !== prevProps.fileDownloadError) {
        toast.error(`File Download Failed: ${fileDownloadError?.message || fileDownloadError}`);
    }

    // This triggers smoothly every time because we reset the value to null afterwards
    if (uploadSuccessMessage && uploadSuccessMessage !== prevProps.uploadSuccessMessage) {
        toast.success(uploadSuccessMessage);
        
        // 1. Instantly clear your local UI file selection state
        this.setState({ 
            transactionFile: null,
            uploadError: []
        });

        if (this.fileInput) {
            this.fileInput.value = '';
        }

        // 2. CRITICAL: Reset the Redux state so the next upload can fire the toast
        this.props.resetBulkUploadState();
        this.props.fetchBulkCaseUpdationList(DEFAULT_FETCH_LIST_REQUEST);
    }

    if (downloadError && downloadError !== prevProps.downloadError) {
        toast.error(`Download Failed: ${downloadError?.message || downloadError}`);
    }
    
    if (uploadError && uploadError !== prevProps.uploadError) {

        toast.error(`Upload Failed: ${uploadError?.message || uploadError}`);
               this.setState({ 
        transactionFile: null,
        uploadError: uploadError // capture to display on screen if needed
    });
    if (this.fileInput) {
        this.fileInput.value = ''; 
    }

    // 3. Clean up the Redux tracking pipeline 
    this.props.resetBulkUploadState();

    }
}
    toggleFilterPanel = () => {
        this.setState(prevState => ({ isFilterOpen: !prevState.isFilterOpen }));
    }

   handleCorporateSearchChange = (e) => {
    const value = e.target.value;
    this.setState({ corporateSearchTerm: value });

    if (this.debounceTimer) clearTimeout(this.debounceTimer);

    this.debounceTimer = setTimeout(() => {
        if (value.trim().length > 2) {
            // Dispatches the action to trigger your corporateSaga pipeline
            this.props.fetchCorporateAutocomplete(value);
        }
    }, 400);
}

    handleCorporateSelect = (selectedOption) => {
        if (!selectedOption) {
            this.setState({
                selectedCorporate: null,
                selectedProducts: []
            });
            return;
        }

        this.setState({
            selectedCorporate: selectedOption,
            selectedProducts: []
        }, () => {
            this.fetchProductsForCorporate(selectedOption.corporateId);
        });
    }

    // 2. UPDATED TO TRIGGER THE SAGA CHANNEL DIRECTLY
    fetchProductsForCorporate = (corporateId) => {
        if (corporateId) {
            this.props.fetchProductsByCorporate(corporateId);
        }
    }

    handleProductDropdownChange = (selectedOptions) => {
        this.setState({ selectedProducts: selectedOptions || [] });
    }

    // Updated status filter handler for dropdown
    handleStatusFilterChange = (selectedOptions) => {
      this.setState({ selectedStatusFilter: selectedOptions || [] });


    const statuses = selectedOptions 
        ? selectedOptions.map(option => option.value) 
        : [];

    this.setState({ selectedStatuses: statuses });
    }

    handleDownloadExcel = () => {
        const { selectedCorporate, selectedProducts, selectedStatuses, startDate, endDate } = this.state;

        if (!selectedStatuses || selectedStatuses.length === 0) {
            toast.error("Validation Error: Please select a filter processing status before downloading.");
            return;
        }

        if (startDate && endDate) {
            const start = new Date(startDate);
            const end = new Date(endDate);
            if (start > end) {
                toast.error("Validation Error: 'Start Date' cannot be after 'End Date'. Please check your creation range.");
                return;
            }
        }

        const payload = {
            corporateId: selectedCorporate?.corporateId || null,
            status: selectedStatuses, // Extracting the single selected status string
            productIds: selectedProducts.map(p => p.value || p), // Maps multi-select instances nicely
            startDate: startDate || null,
            endDate: endDate || null
        };

        console.log('Dispatching export engine payload to Saga: ', payload);
        
        this.props.downloadBulkReportExcel(payload);
    }

    uploadExcel = (e) => {
    const file = e.target.files[0];
    if (file) {
        this.setState({ 
            transactionFile: file,
            uploadError: null 
        });
    }
}

    handleClear = () => {
    this.setState({ 
        transactionFile: null,
        uploadError: null 
    });
    if (this.fileInput) {
        this.fileInput.value = ''; // Safely clears the physical HTML file input UI element
    }
}

   handleSubmit = () => {
    const { transactionFile } = this.state;

    // Guard Clause: Prevent clicking submit if no file is selected yet
    if (!transactionFile) {
        toast.error("Please select a valid Excel file before submitting.");
        return;
    }

    console.log('Submitting operational execution dataset...');
    
    // Wrap the file inside the multipart container right here at the moment of submission
    const formData = new FormData();
    formData.append("file", transactionFile); // Matches your Spring Controller parameter name

    // Dispatch your Redux action to start the Saga pipeline
    this.props.updateBulkCases(formData);
}

    uploadFetch = (params) => {
        this.props.fetchBulkCaseUpdationList(params);
    }


    // Custom styles for status dropdown
    getStatusDropdownStyles = () => {
        const customStyles = {
            control: (provided, state) => ({
                ...provided,
                minHeight: '38px',
                borderColor: state.isFocused ? '#80bdff' : '#dee2e6',
                boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(0,123,255,0.25)' : 'none',
                '&:hover': {
                    borderColor: '#80bdff'
                }
            }),
            option: (provided, { isSelected }) => ({
                ...provided,
                backgroundColor: isSelected ? '#e9ecef' : 'white',
                color: '#212529',
                '&:hover': {
                    backgroundColor: '#f8f9fa'
                }
            }),
            singleValue: (provided) => ({
                ...provided,
                color: '#212529',
                display: 'flex',
                alignItems: 'center'
            })
        };
        return customStyles;
    };

    // Custom format for status options with colored dots
    formatStatusOption = (option) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{
                display: 'inline-block',
                width: '10px',
                height: '10px',
                borderRadius: '50%',
                backgroundColor: option.color,
                marginRight: '8px'
            }} />
            <span>{option.label}</span>
        </div>
    );

    // Format selected value with dot
    formatStatusValue = (option) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{
                display: 'inline-block',
                width: '10px',
                height: '10px',
                borderRadius: '50%',
                backgroundColor: option?.color || '#6c757d'
            }} />
            <span>{option?.label || 'Select status...'}</span>
        </div>
    );

    renderSectionHeader = (title, badgeLabel, badgeColor) => (
        <div className="bulk-case-updation__section-header">
            <h5 className="bulk-case-updation__section-title">{title}</h5>
            <Badge color={badgeColor} className="px-2 py-1">{badgeLabel}</Badge>
        </div>
    );

    render() {
        const { isFilterOpen, corporateSearchTerm, selectedCorporate,
                selectedProducts, startDate, endDate,
                transactionFile, uploadError, selectedStatusFilter } = this.state;

        const {
            corporateOptions, corporateLoading, productOptions, isProductLoading,
            productError, corporateError, downloadLoading, uploadListData, uploadListLoading,
        } = this.props;
        return (

            
            <div className="bulk-case-updation w-100" isLoading={downloadLoading}>
                <header className="bulk-case-updation__header d-flex flex-wrap justify-content-between align-items-center">

                    <h4 className="bulk-case-updation__title text-primary">Bulk Case Management</h4>
                    <Button
                        color="secondary"
                        outline
                        size="sm"
                        className="px-3"
                        onClick={this.toggleFilterPanel}
                    >
                        <i className={`fa ${isFilterOpen ? 'fa-chevron-up' : 'fa-chevron-down'} mr-2`} />
                        {isFilterOpen ? 'Hide Export' : 'Show Export'}
                    </Button>
                </header>

                <Collapse isOpen={isFilterOpen} className="mb-4">
                    <Card className="bulk-case-updation__section-card bulk-case-updation__export-panel p-3 p-xl-4">
                       

                        <div className="bulk-case-updation__filter-grid">
                          {/* ========================================================= */}

<FormGroup 
    className={`bulk-case-updation__field mb-0 ${corporateError ? 'has-error' : ''}`}
    title={corporateError ? `Error: ${corporateError}` : undefined}
>
    <div className="form-group mb-2">
        <Label className={`font-weight-bold small ${corporateError ? 'text-danger' : 'text-secondary'}`}>
            Search Corporate Identity
            {corporateError && <span className="ml-1 text-danger">(⚠️ Hover to view error)</span>}
        </Label>
        
        <div className="animate-fade-in">
            <Select
                isSearchable
                isClearable
                classNamePrefix="react-select-custom" // CRITICAL: This links directly to your SCSS rules above!
                options={corporateOptions}
                value={selectedCorporate}
                isLoading={corporateLoading}
                isDisabled={!!corporateError}
                placeholder={
                    corporateError 
                        ? `Failed: ${corporateError}` 
                        : corporateLoading 
                            ? "Searching..." 
                            : "Type corporate name to search..."
                }
                onInputChange={(newValue) => {
                    if (this.handleCorporateSearchChange) {
                        this.handleCorporateSearchChange({ target: { value: newValue } });
                    }
                }}
                onChange={this.handleCorporateSelect}
                noOptionsMessage={({ inputValue }) => 
                    !inputValue || inputValue.trim().length <= 2 
                        ? "Type at least 3 characters to search" 
                        : "No companies found"
                }
                // STYLES PROP COMPLETELY REMOVED FROM HERE
            />
        </div>
    </div>
</FormGroup>


<FormGroup 
    className={`bulk-case-updation__field mb-0 ${productError ? 'has-error' : ''}`}
    title={productError ? `Error: ${productError}` : undefined}
>
    <Label className={`font-weight-bold small ${productError ? 'text-danger' : 'text-secondary'}`}>
        Target Products Mapped
        {productError && <span className="ml-1 text-danger">(⚠️ Hover to view error)</span>}
    </Label>
    
    <Select
        isMulti
        placeholder={
            productError
                ? `Failed: ${productError}`
                : isProductLoading 
                    ? 'Fetching mapped products...' 
                    : selectedCorporate 
                        ? 'Select products...' 
                        : 'Select a corporate first'
        }
        options={productOptions}
        value={selectedProducts}
        onChange={this.handleProductDropdownChange}
        isDisabled={!selectedCorporate || isProductLoading || !!productError}
        isLoading={isProductLoading}
        classNamePrefix="react-select-custom"
        styles={{
            control: (base) => ({
                ...base,
                borderColor: productError ? '#dc3545' : base.borderColor,
                '&:hover': {
                    borderColor: productError ? '#dc3545' : base.borderColor
                }
            })
        }}
    />
</FormGroup>

                          <FormGroup className="bulk-case-updation__field mb-0">
    <Label className="font-weight-bold small text-secondary d-block">Filter Processing Status</Label>
    <Select
        isMulti // CRITICAL: This enables multi-selection with standard chip elements
        isClearable={true} // Allows users to clear all selected statuses with a single click
        closeMenuOnSelect={false} // Keeps dropdown open so users can pick multiple chips easily
        placeholder="Select status to filter..."
        options={STATUS_DROPDOWN_OPTIONS}
        value={selectedStatusFilter} // Expects an array of objects now: [{value: '...', label: '...'}, ...]
        onChange={this.handleStatusFilterChange}
        styles={this.getStatusDropdownStyles()}
        formatOptionLabel={this.formatStatusOption}
        formatGroupLabel={this.formatStatusOption}
        classNamePrefix="react-select-status"
        menuPlacement="auto"
    />
    
    {/* Dynamic Selection Summary Display for Chips */}
    {Array.isArray(selectedStatusFilter) && selectedStatusFilter.length > 0 && (
        <div className="mt-2 small text-muted d-flex flex-wrap align-items-center">
            <i className="fa fa-info-circle mr-1" />
            Filtering by ({selectedStatusFilter.length}): 
            <div className="d-inline-flex flex-wrap gap-1 ml-1">
                {selectedStatusFilter.map((status, idx) => (
                    <span key={idx} className="badge badge-secondary px-2 py-1 mx-1 shadow-sm font-weight-bold">
                        {status.label}
                    </span>
                ))}
            </div>
        </div>
    )}
</FormGroup>
                        </div>

                        <div className="bulk-case-updation__filter-grid bulk-case-updation__filter-grid--dates mt-3 mt-xl-4">
                            <FormGroup className="bulk-case-updation__field mb-0">
                                <Label className="font-weight-bold small text-secondary">Creation Range: Start Date</Label>
                                <Input
                                    type="date"
                                    className="custom-form-input"
                                    value={startDate}
                                    onChange={e => this.setState({ startDate: e.target.value })}
                                />
                            </FormGroup>

                            <FormGroup className="bulk-case-updation__field mb-0">
                                <Label className="font-weight-bold small text-secondary">Creation Range: End Date</Label>
                                <Input
                                    type="date"
                                    className="custom-form-input"
                                    value={endDate}
                                    onChange={e => this.setState({ endDate: e.target.value })}
                                />
                            </FormGroup>

                            <div className="bulk-case-updation__field download-btn-container">
                                <Button
                                    color="success"
                                    block
                                    className="font-weight-bold shadow-sm d-flex align-items-center justify-content-center custom-action-btn"
                                    onClick={this.handleDownloadExcel}
                                >
                                    <i className="fa fa-download mr-2" />
                                    Download Formatted Target Excel
                                </Button>
                            </div>
                        </div>
                    </Card>
                </Collapse>

                <Card className="bulk-case-updation__section-card p-3 p-xl-4">
                   
                 <div>
    {/* 1. Flex Container holding only the two control inputs side-by-side */}
    <div className="bulk-case-updation__upload-bar d-flex align-items-end gap-3">
        <FormGroup className="mb-0 flex-grow-1">
            <Label className="text-secondary font-weight-bold small d-block mb-2">Excel Sheet Uploader</Label>
            <div className="position-relative">
                <Button
                    color="primary"
                    block
                    className="position-relative overflow-hidden py-2 d-flex align-items-center justify-content-center custom-action-btn"
                >
                    <i className="fa fa-paperclip mr-2" />
                    Browse File(s)
                    <input
                        onChange={this.uploadExcel}
                        type="file"
                        name="file"
                        id="bulk-case-updation-file"
                        ref={(el) => { this.fileInput = el; }}
                        className="position-absolute w-100 h-100 cursor-pointer"
                        style={{ top: 0, left: 0, opacity: 0, zIndex: 2 }}
                    />
                </Button>
            </div>
        </FormGroup>

        <FormGroup className="mb-0">
            {/* Kept d-block to match the alignment height across viewports */}
            <Label className="text-secondary font-weight-bold small d-block mb-2 text-transparent" style={{ visibility: 'hidden' }}>Execute</Label>
            <Button
                color="primary"
                block
                className="py-2 font-weight-bold shadow-sm d-flex align-items-center justify-content-center custom-action-btn"
                onClick={this.handleSubmit}
                disabled={!transactionFile} // Standard production UX safety
            >
                <i className="fa fa-cloud-upload mr-2" />
                Run
            </Button>
        </FormGroup>
    </div>

    {/* 2. Displaced File-State Indicator (Pushed completely out of the flex-row alignment context) */}
    {transactionFile && (
        <div className="mt-2" style={{ maxWidth: '300px' }}>
            <div className="alert alert-info py-2 px-3 small d-flex align-items-center mb-0 border-0 shadow-sm animate-fade-in">
                <i className="fa fa-file-excel-o mr-2 text-success" />
                <span className="text-truncate font-weight-medium text-dark w-100">
                    {transactionFile.name}
                </span>
            </div>
        </div>
    )}
</div>

                    {Array.isArray(uploadError) && uploadError.length > 0 && (
                        <div className="mt-4 p-3 bg-light rounded border border-danger animate-fade-in">
                            <div className="d-flex flex-wrap justify-content-between align-items-center mb-2">
                                <span className="text-danger font-weight-bold small">
                                    <i className="fa fa-warning mr-2" />
                                    Ingestion Violations Found:
                                </span>
                                <span
                                    className="text-muted small cursor-pointer font-weight-medium"
                                    onClick={this.handleClear}
                                    role="button"
                                    tabIndex={0}
                                    onKeyPress={this.handleClear}
                                >
                                    Clear Errors
                                </span>
                            </div>
                            <ul className="pl-3 mb-0 text-danger small">
                                {uploadError.map((data, index) => (
                                    <li className="upload-error py-1" key={index}>
                                        {index + 1} - {data}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}

                    <div className="bulk-case-updation__table-region">
                        <div className="bulk-case-updation__table-scroll">
                            <TableView
                                tasks={uploadListData}
                                loading={uploadListLoading}
                                onFetchPage={this.uploadFetch}
                                onDownloadFile={this.props.downloadBulkCaseUpdationFile}
                            />
                        </div>
                    </div>
                </Card>
            </div>
        );
    }
}

// 4. CONNECT REDUX STORE DATA ELEMENTS TO THE PROPERTIES CONTEXT
const mapStateToProps = (state) => {
    const { bulkCaseUpdation, signUpDetails } = state;

    return {
        corporateOptions: (bulkCaseUpdation?.corporateList || []).map(corp => ({
            value: corp.id,
            label: `${corp.corporateName} ${corp.gstNo ? `(${corp.gstNo})` : ''}`,
            corporateId: corp.id,
        })),
        corporateLoading: bulkCaseUpdation?.corporateLoading || false,
        corporateError: bulkCaseUpdation?.corporateError || null,

        productOptions: bulkCaseUpdation?.productList || [],
        isProductLoading: bulkCaseUpdation?.productLoading || false,
        productError: bulkCaseUpdation?.productError || null,

        downloadLoading: bulkCaseUpdation?.isDownloading || false,
        downloadError: bulkCaseUpdation?.downloadError || null,

        uploadLoading: bulkCaseUpdation?.uploadLoading || false,
        uploadError: bulkCaseUpdation?.uploadError || null,
        uploadSuccessMessage: bulkCaseUpdation?.uploadSuccessMessage || null,

        uploadListData: bulkCaseUpdation?.uploadListData || {},
        uploadListLoading: bulkCaseUpdation?.uploadListLoading || false,
        uploadListError: bulkCaseUpdation?.uploadListError || null,

        fileDownloadLoading: bulkCaseUpdation?.fileDownloadLoading || false,
        fileDownloadUrl: bulkCaseUpdation?.fileDownloadUrl || null,
        fileDownloadError: bulkCaseUpdation?.fileDownloadError || null,

        currentUser: signUpDetails?.userDetails || null,
    };
};


const mapDispatchToProps = (dispatch) => ({
    fetchCorporateAutocomplete: (searchTerm) => dispatch(fetchCorporateAutocomplete(searchTerm)),
    fetchProductsByCorporate: (corporateId) => dispatch(fetchProductsByCorporate(corporateId)),
    downloadBulkReportExcel: (payload) => dispatch(downloadBulkReportExcel(payload)),
    updateBulkCases: (payload) => dispatch(updateBulkCases(payload)),
    fetchBulkCaseUpdationList: (params) => dispatch(fetchBulkCaseUpdationList(params)),
    resetBulkUploadState: () => dispatch(resetBulkUploadState()),
    downloadBulkCaseUpdationFile: (fileKey) => dispatch(downloadBulkCaseUpdationFile(fileKey)),
    preloading: data => dispatch(preloading(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(CreateBulkCaseUpdation);